<template>
  <div class="blog-post__person">
    <span class="blog-post__person-link color--red">
      <bi-picture
        class="blog-post__person-image"
        :thumb-formats="author.avatar.formats"
        :code="author.avatar.code"
        :thumb-sizes="author.avatar.sizes"
      ></bi-picture>
      <div class="blog-post__person-name">{{ author.name }}</div>
    </span>
    <ul class="blog-post__person-info">
      <li>{{ author.role }}</li>
      <li>Mini DAYZ Branch</li>
      <!-- -->
      <li>
        Twitter:
        <a
          :href="`https://twitter.com/${author.twitter}`"
          target="_blank"
          rel="nofollow me noopener noreferrer"
          >@{{ author.twitter }}</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
import BiPicture from "../../partials/BiPicture";

export default {
  name: "BlogPostAuthor",
  components: {
    BiPicture
  },
  props: {
    author: Object
  }
};
</script>

<style scoped></style>
